import { Directive, ElementRef, Renderer2, HostListener, Input, OnInit } from '@angular/core';
import * as $ from 'jquery';
import {ProductsService} from '../services/products.service';

@Directive({
  selector: '[appVariationbtn]'
})
export class VariationbtnDirective {
  @Input('dAction') dAction:string;
  @Input('radioBtn') radioBtn:string;
  @Input('opvn') opvn:string;
  
  radioArr:any = []; 

  constructor(private renderer:Renderer2, private el:ElementRef,  private prodObj:ProductsService) {}

  ngOnInit(){}

  @HostListener('click') onClick() {

    let btnContParent =   this.renderer.parentNode(this.el.nativeElement);
    let qtyFormCont = this.renderer.parentNode(btnContParent);
    let optncnt = this.renderer.parentNode(qtyFormCont);

    let chkbox = optncnt.querySelector('.optnchk');
    let vqty = parseInt(chkbox.getAttribute('qty'));

    if(this.dAction == 'add'){
      vqty++;
    }else{
      if(vqty != 0){
        vqty--;
      }
    }
    
    let btnqty = btnContParent.querySelector('.optnqty');
    btnqty.innerText = vqty;
    
    this.renderer.setAttribute(chkbox, 'qty', vqty.toString());
    this.renderer.setProperty(chkbox, 'checked', true);
    this.prodObj.varientqtyArr.emit(this.radioArr);
  }
  
}
